var map = {
	"./icon-3d-model.svg": "./src/assets/icons/icon-3d-model.svg",
	"./icon-CA.svg": "./src/assets/icons/icon-CA.svg",
	"./icon-DE.svg": "./src/assets/icons/icon-DE.svg",
	"./icon-US.svg": "./src/assets/icons/icon-US.svg",
	"./icon-account.svg": "./src/assets/icons/icon-account.svg",
	"./icon-arrow--cta-long.svg": "./src/assets/icons/icon-arrow--cta-long.svg",
	"./icon-arrow--cta.svg": "./src/assets/icons/icon-arrow--cta.svg",
	"./icon-arrow--down.svg": "./src/assets/icons/icon-arrow--down.svg",
	"./icon-arrow--left--custom.svg": "./src/assets/icons/icon-arrow--left--custom.svg",
	"./icon-arrow--left.svg": "./src/assets/icons/icon-arrow--left.svg",
	"./icon-arrow--right--custom.svg": "./src/assets/icons/icon-arrow--right--custom.svg",
	"./icon-arrow--right.svg": "./src/assets/icons/icon-arrow--right.svg",
	"./icon-arrow--up.svg": "./src/assets/icons/icon-arrow--up.svg",
	"./icon-cart.svg": "./src/assets/icons/icon-cart.svg",
	"./icon-check--circle.svg": "./src/assets/icons/icon-check--circle.svg",
	"./icon-checkmark.svg": "./src/assets/icons/icon-checkmark.svg",
	"./icon-chevron.svg": "./src/assets/icons/icon-chevron.svg",
	"./icon-circle-checkmark.svg": "./src/assets/icons/icon-circle-checkmark.svg",
	"./icon-close.svg": "./src/assets/icons/icon-close.svg",
	"./icon-fill.svg": "./src/assets/icons/icon-fill.svg",
	"./icon-filters-sort.svg": "./src/assets/icons/icon-filters-sort.svg",
	"./icon-less.svg": "./src/assets/icons/icon-less.svg",
	"./icon-lock.svg": "./src/assets/icons/icon-lock.svg",
	"./icon-minus.svg": "./src/assets/icons/icon-minus.svg",
	"./icon-more.svg": "./src/assets/icons/icon-more.svg",
	"./icon-pause--white.svg": "./src/assets/icons/icon-pause--white.svg",
	"./icon-pause.svg": "./src/assets/icons/icon-pause.svg",
	"./icon-play--square.svg": "./src/assets/icons/icon-play--square.svg",
	"./icon-play.svg": "./src/assets/icons/icon-play.svg",
	"./icon-plus.svg": "./src/assets/icons/icon-plus.svg",
	"./icon-remove.svg": "./src/assets/icons/icon-remove.svg",
	"./icon-return.svg": "./src/assets/icons/icon-return.svg",
	"./icon-search.svg": "./src/assets/icons/icon-search.svg",
	"./icon-shipping-message.svg": "./src/assets/icons/icon-shipping-message.svg",
	"./icon-shipping.svg": "./src/assets/icons/icon-shipping.svg",
	"./icon-tail.svg": "./src/assets/icons/icon-tail.svg",
	"./icon-tooltip.svg": "./src/assets/icons/icon-tooltip.svg",
	"./icon-trail-marker.svg": "./src/assets/icons/icon-trail-marker.svg",
	"./icon-warranty-message.svg": "./src/assets/icons/icon-warranty-message.svg",
	"./social-icons/icon-facebook.svg": "./src/assets/icons/social-icons/icon-facebook.svg",
	"./social-icons/icon-instagram.svg": "./src/assets/icons/social-icons/icon-instagram.svg",
	"./social-icons/icon-linkedin.svg": "./src/assets/icons/social-icons/icon-linkedin.svg",
	"./social-icons/icon-pinterest.svg": "./src/assets/icons/social-icons/icon-pinterest.svg",
	"./social-icons/icon-rss.svg": "./src/assets/icons/social-icons/icon-rss.svg",
	"./social-icons/icon-shopify-logo.svg": "./src/assets/icons/social-icons/icon-shopify-logo.svg",
	"./social-icons/icon-snapchat.svg": "./src/assets/icons/social-icons/icon-snapchat.svg",
	"./social-icons/icon-tumblr.svg": "./src/assets/icons/social-icons/icon-tumblr.svg",
	"./social-icons/icon-twitter.svg": "./src/assets/icons/social-icons/icon-twitter.svg",
	"./social-icons/icon-vimeo.svg": "./src/assets/icons/social-icons/icon-vimeo.svg",
	"./social-icons/icon-youtube.svg": "./src/assets/icons/social-icons/icon-youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive \\.svg$";